<template>
    <div>
        <div class="flex items-end justify-between mb-2" v-if="label">
            <label class="flex items-center text-sm text-gray-600">
                <span class="font-medium text-gray-700" v-text="label" />
                <slot name="after-label" />
            </label>
            <slot name="right-label">
                <span class="text-sm text-gray-600" v-text="hint" v-if="hint" />
            </slot>
        </div>
        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: '',
            },
            hint: {
                type: String,
                default: '',
            },
        },
    };
</script>
